import StockApi from 'src/services/StockApi'
import { resultToFailed, resultToSuccess } from '../Helper'

export const validUserByBarcode = async (barcodeUser) => {
  try {
    const result = await StockApi.get('/usuario/valida', {
      params: { barcodeUser }
    })
    return resultToSuccess(result)
  } catch (e) {
    return resultToFailed(e)
  }
}
